/* GENERATED FILE */
/* to regenerate, run 'yarn generate-icon-map' */

import AddressBook from 'phosphor-react-native/src/icons/AddressBook'
import AlignLeft from 'phosphor-react-native/src/icons/AlignLeft'
import AppleLogo from 'phosphor-react-native/src/icons/AppleLogo'
import ArrowBendUpLeft from 'phosphor-react-native/src/icons/ArrowBendUpLeft'
import ArrowClockwise from 'phosphor-react-native/src/icons/ArrowClockwise'
import ArrowCounterClockwise from 'phosphor-react-native/src/icons/ArrowCounterClockwise'
import ArrowLeft from 'phosphor-react-native/src/icons/ArrowLeft'
import ArrowLineRight from 'phosphor-react-native/src/icons/ArrowLineRight'
import ArrowRight from 'phosphor-react-native/src/icons/ArrowRight'
import ArrowSquareRight from 'phosphor-react-native/src/icons/ArrowSquareRight'
import ArrowsClockwise from 'phosphor-react-native/src/icons/ArrowsClockwise'
import ArrowsDownUp from 'phosphor-react-native/src/icons/ArrowsDownUp'
import ArrowsLeftRight from 'phosphor-react-native/src/icons/ArrowsLeftRight'
import ArrowsOutSimple from 'phosphor-react-native/src/icons/ArrowsOutSimple'
import Avocado from 'phosphor-react-native/src/icons/Avocado'
import Baby from 'phosphor-react-native/src/icons/Baby'
import Barbell from 'phosphor-react-native/src/icons/Barbell'
import Barcode from 'phosphor-react-native/src/icons/Barcode'
import Bed from 'phosphor-react-native/src/icons/Bed'
import Bell from 'phosphor-react-native/src/icons/Bell'
import BellRinging from 'phosphor-react-native/src/icons/BellRinging'
import BellSimple from 'phosphor-react-native/src/icons/BellSimple'
import Bluetooth from 'phosphor-react-native/src/icons/Bluetooth'
import Bone from 'phosphor-react-native/src/icons/Bone'
import BookOpen from 'phosphor-react-native/src/icons/BookOpen'
import BookOpenText from 'phosphor-react-native/src/icons/BookOpenText'
import BookmarkSimple from 'phosphor-react-native/src/icons/BookmarkSimple'
import BowlFood from 'phosphor-react-native/src/icons/BowlFood'
import Brain from 'phosphor-react-native/src/icons/Brain'
import Cake from 'phosphor-react-native/src/icons/Cake'
import Calculator from 'phosphor-react-native/src/icons/Calculator'
import Calendar from 'phosphor-react-native/src/icons/Calendar'
import CalendarBlank from 'phosphor-react-native/src/icons/CalendarBlank'
import CalendarCheck from 'phosphor-react-native/src/icons/CalendarCheck'
import CalendarPlus from 'phosphor-react-native/src/icons/CalendarPlus'
import CalendarX from 'phosphor-react-native/src/icons/CalendarX'
import Camera from 'phosphor-react-native/src/icons/Camera'
import CaretDown from 'phosphor-react-native/src/icons/CaretDown'
import CaretLeft from 'phosphor-react-native/src/icons/CaretLeft'
import CaretRight from 'phosphor-react-native/src/icons/CaretRight'
import CaretUp from 'phosphor-react-native/src/icons/CaretUp'
import Carrot from 'phosphor-react-native/src/icons/Carrot'
import ChartBar from 'phosphor-react-native/src/icons/ChartBar'
import ChartLine from 'phosphor-react-native/src/icons/ChartLine'
import ChartLineUp from 'phosphor-react-native/src/icons/ChartLineUp'
import Chat from 'phosphor-react-native/src/icons/Chat'
import ChatCircle from 'phosphor-react-native/src/icons/ChatCircle'
import ChatCircleText from 'phosphor-react-native/src/icons/ChatCircleText'
import ChatText from 'phosphor-react-native/src/icons/ChatText'
import ChatsCircle from 'phosphor-react-native/src/icons/ChatsCircle'
import Check from 'phosphor-react-native/src/icons/Check'
import CheckCircle from 'phosphor-react-native/src/icons/CheckCircle'
import Checks from 'phosphor-react-native/src/icons/Checks'
import Circle from 'phosphor-react-native/src/icons/Circle'
import CircleDashed from 'phosphor-react-native/src/icons/CircleDashed'
import Clock from 'phosphor-react-native/src/icons/Clock'
import ClockCountdown from 'phosphor-react-native/src/icons/ClockCountdown'
import ClockCounterClockwise from 'phosphor-react-native/src/icons/ClockCounterClockwise'
import Cloud from 'phosphor-react-native/src/icons/Cloud'
import CloudArrowUp from 'phosphor-react-native/src/icons/CloudArrowUp'
import Coin from 'phosphor-react-native/src/icons/Coin'
import Coins from 'phosphor-react-native/src/icons/Coins'
import Command from 'phosphor-react-native/src/icons/Command'
import Confetti from 'phosphor-react-native/src/icons/Confetti'
import Cookie from 'phosphor-react-native/src/icons/Cookie'
import Copy from 'phosphor-react-native/src/icons/Copy'
import CornersOut from 'phosphor-react-native/src/icons/CornersOut'
import CreditCard from 'phosphor-react-native/src/icons/CreditCard'
import DeviceMobileCamera from 'phosphor-react-native/src/icons/DeviceMobileCamera'
import DotsSixVertical from 'phosphor-react-native/src/icons/DotsSixVertical'
import DotsThree from 'phosphor-react-native/src/icons/DotsThree'
import DotsThreeVertical from 'phosphor-react-native/src/icons/DotsThreeVertical'
import Drop from 'phosphor-react-native/src/icons/Drop'
import EnvelopeOpen from 'phosphor-react-native/src/icons/EnvelopeOpen'
import EnvelopeSimple from 'phosphor-react-native/src/icons/EnvelopeSimple'
import Export from 'phosphor-react-native/src/icons/Export'
import Eye from 'phosphor-react-native/src/icons/Eye'
import EyeClosed from 'phosphor-react-native/src/icons/EyeClosed'
import FacebookLogo from 'phosphor-react-native/src/icons/FacebookLogo'
import FadersHorizontal from 'phosphor-react-native/src/icons/FadersHorizontal'
import FileArrowDown from 'phosphor-react-native/src/icons/FileArrowDown'
import FileText from 'phosphor-react-native/src/icons/FileText'
import Files from 'phosphor-react-native/src/icons/Files'
import FirstAid from 'phosphor-react-native/src/icons/FirstAid'
import Fish from 'phosphor-react-native/src/icons/Fish'
import Flag from 'phosphor-react-native/src/icons/Flag'
import Flame from 'phosphor-react-native/src/icons/Flame'
import Flask from 'phosphor-react-native/src/icons/Flask'
import FlowerLotus from 'phosphor-react-native/src/icons/FlowerLotus'
import Footprints from 'phosphor-react-native/src/icons/Footprints'
import ForkKnife from 'phosphor-react-native/src/icons/ForkKnife'
import Funnel from 'phosphor-react-native/src/icons/Funnel'
import Gauge from 'phosphor-react-native/src/icons/Gauge'
import Gear from 'phosphor-react-native/src/icons/Gear'
import GenderFemale from 'phosphor-react-native/src/icons/GenderFemale'
import GenderMale from 'phosphor-react-native/src/icons/GenderMale'
import Gift from 'phosphor-react-native/src/icons/Gift'
import Grains from 'phosphor-react-native/src/icons/Grains'
import Hamburger from 'phosphor-react-native/src/icons/Hamburger'
import HandHeart from 'phosphor-react-native/src/icons/HandHeart'
import HandWaving from 'phosphor-react-native/src/icons/HandWaving'
import Heart from 'phosphor-react-native/src/icons/Heart'
import Heartbeat from 'phosphor-react-native/src/icons/Heartbeat'
import HourglassSimpleMedium from 'phosphor-react-native/src/icons/HourglassSimpleMedium'
import HouseSimple from 'phosphor-react-native/src/icons/HouseSimple'
import IdentificationCard from 'phosphor-react-native/src/icons/IdentificationCard'
import Image from 'phosphor-react-native/src/icons/Image'
import Info from 'phosphor-react-native/src/icons/Info'
import InstagramLogo from 'phosphor-react-native/src/icons/InstagramLogo'
import JarLabel from 'phosphor-react-native/src/icons/JarLabel'
import Key from 'phosphor-react-native/src/icons/Key'
import Lifebuoy from 'phosphor-react-native/src/icons/Lifebuoy'
import Lightbulb from 'phosphor-react-native/src/icons/Lightbulb'
import LightbulbFilament from 'phosphor-react-native/src/icons/LightbulbFilament'
import Lightning from 'phosphor-react-native/src/icons/Lightning'
import LightningSlash from 'phosphor-react-native/src/icons/LightningSlash'
import Link from 'phosphor-react-native/src/icons/Link'
import LinkSimpleHorizontal from 'phosphor-react-native/src/icons/LinkSimpleHorizontal'
import ListBullets from 'phosphor-react-native/src/icons/ListBullets'
import ListChecks from 'phosphor-react-native/src/icons/ListChecks'
import Lock from 'phosphor-react-native/src/icons/Lock'
import LockSimple from 'phosphor-react-native/src/icons/LockSimple'
import LockSimpleOpen from 'phosphor-react-native/src/icons/LockSimpleOpen'
import MagnifyingGlass from 'phosphor-react-native/src/icons/MagnifyingGlass'
import Microphone from 'phosphor-react-native/src/icons/Microphone'
import MicrophoneSlash from 'phosphor-react-native/src/icons/MicrophoneSlash'
import Microscope from 'phosphor-react-native/src/icons/Microscope'
import Minus from 'phosphor-react-native/src/icons/Minus'
import Moon from 'phosphor-react-native/src/icons/Moon'
import MoonStars from 'phosphor-react-native/src/icons/MoonStars'
import Note from 'phosphor-react-native/src/icons/Note'
import NotePencil from 'phosphor-react-native/src/icons/NotePencil'
import Notepad from 'phosphor-react-native/src/icons/Notepad'
import PaperPlaneTilt from 'phosphor-react-native/src/icons/PaperPlaneTilt'
import Pause from 'phosphor-react-native/src/icons/Pause'
import PauseCircle from 'phosphor-react-native/src/icons/PauseCircle'
import Pen from 'phosphor-react-native/src/icons/Pen'
import Pencil from 'phosphor-react-native/src/icons/Pencil'
import PencilLine from 'phosphor-react-native/src/icons/PencilLine'
import PencilSimple from 'phosphor-react-native/src/icons/PencilSimple'
import PencilSimpleLine from 'phosphor-react-native/src/icons/PencilSimpleLine'
import Percent from 'phosphor-react-native/src/icons/Percent'
import PersonArmsSpread from 'phosphor-react-native/src/icons/PersonArmsSpread'
import PersonSimple from 'phosphor-react-native/src/icons/PersonSimple'
import PersonSimpleBike from 'phosphor-react-native/src/icons/PersonSimpleBike'
import PersonSimpleRun from 'phosphor-react-native/src/icons/PersonSimpleRun'
import PersonSimpleSwim from 'phosphor-react-native/src/icons/PersonSimpleSwim'
import PersonSimpleWalk from 'phosphor-react-native/src/icons/PersonSimpleWalk'
import Pill from 'phosphor-react-native/src/icons/Pill'
import PintGlass from 'phosphor-react-native/src/icons/PintGlass'
import Plant from 'phosphor-react-native/src/icons/Plant'
import Play from 'phosphor-react-native/src/icons/Play'
import PlayCircle from 'phosphor-react-native/src/icons/PlayCircle'
import Plus from 'phosphor-react-native/src/icons/Plus'
import Prohibit from 'phosphor-react-native/src/icons/Prohibit'
import Pulse from 'phosphor-react-native/src/icons/Pulse'
import PushPin from 'phosphor-react-native/src/icons/PushPin'
import Question from 'phosphor-react-native/src/icons/Question'
import RadioButton from 'phosphor-react-native/src/icons/RadioButton'
import Record from 'phosphor-react-native/src/icons/Record'
import Ruler from 'phosphor-react-native/src/icons/Ruler'
import Scales from 'phosphor-react-native/src/icons/Scales'
import Scan from 'phosphor-react-native/src/icons/Scan'
import Seal from 'phosphor-react-native/src/icons/Seal'
import SealCheck from 'phosphor-react-native/src/icons/SealCheck'
import SealQuestion from 'phosphor-react-native/src/icons/SealQuestion'
import SelectionSlash from 'phosphor-react-native/src/icons/SelectionSlash'
import Share from 'phosphor-react-native/src/icons/Share'
import ShareNetwork from 'phosphor-react-native/src/icons/ShareNetwork'
import ShieldCheck from 'phosphor-react-native/src/icons/ShieldCheck'
import ShieldSlash from 'phosphor-react-native/src/icons/ShieldSlash'
import ShieldStar from 'phosphor-react-native/src/icons/ShieldStar'
import ShieldWarning from 'phosphor-react-native/src/icons/ShieldWarning'
import ShoppingCart from 'phosphor-react-native/src/icons/ShoppingCart'
import ShoppingCartSimple from 'phosphor-react-native/src/icons/ShoppingCartSimple'
import SignOut from 'phosphor-react-native/src/icons/SignOut'
import SlidersHorizontal from 'phosphor-react-native/src/icons/SlidersHorizontal'
import Smiley from 'phosphor-react-native/src/icons/Smiley'
import Sparkle from 'phosphor-react-native/src/icons/Sparkle'
import SpeakerLow from 'phosphor-react-native/src/icons/SpeakerLow'
import SpeakerSimpleHigh from 'phosphor-react-native/src/icons/SpeakerSimpleHigh'
import SpeakerSimpleSlash from 'phosphor-react-native/src/icons/SpeakerSimpleSlash'
import SquaresFour from 'phosphor-react-native/src/icons/SquaresFour'
import Stack from 'phosphor-react-native/src/icons/Stack'
import Star from 'phosphor-react-native/src/icons/Star'
import StarFour from 'phosphor-react-native/src/icons/StarFour'
import Steps from 'phosphor-react-native/src/icons/Steps'
import Stethoscope from 'phosphor-react-native/src/icons/Stethoscope'
import Syringe from 'phosphor-react-native/src/icons/Syringe'
import Tag from 'phosphor-react-native/src/icons/Tag'
import Target from 'phosphor-react-native/src/icons/Target'
import TestTube from 'phosphor-react-native/src/icons/TestTube'
import Thermometer from 'phosphor-react-native/src/icons/Thermometer'
import ThumbsDown from 'phosphor-react-native/src/icons/ThumbsDown'
import ThumbsUp from 'phosphor-react-native/src/icons/ThumbsUp'
import Timer from 'phosphor-react-native/src/icons/Timer'
import Trash from 'phosphor-react-native/src/icons/Trash'
import TrashSimple from 'phosphor-react-native/src/icons/TrashSimple'
import TrendUp from 'phosphor-react-native/src/icons/TrendUp'
import Triangle from 'phosphor-react-native/src/icons/Triangle'
import Truck from 'phosphor-react-native/src/icons/Truck'
import User from 'phosphor-react-native/src/icons/User'
import UserPlus from 'phosphor-react-native/src/icons/UserPlus'
import Users from 'phosphor-react-native/src/icons/Users'
import Video from 'phosphor-react-native/src/icons/Video'
import VideoCamera from 'phosphor-react-native/src/icons/VideoCamera'
import Virus from 'phosphor-react-native/src/icons/Virus'
import Warning from 'phosphor-react-native/src/icons/Warning'
import WarningCircle from 'phosphor-react-native/src/icons/WarningCircle'
import WarningOctagon from 'phosphor-react-native/src/icons/WarningOctagon'
import WaveTriangle from 'phosphor-react-native/src/icons/WaveTriangle'
import Waveform from 'phosphor-react-native/src/icons/Waveform'
import Waves from 'phosphor-react-native/src/icons/Waves'
import WifiX from 'phosphor-react-native/src/icons/WifiX'
import Wine from 'phosphor-react-native/src/icons/Wine'
import X from 'phosphor-react-native/src/icons/X'
import XCircle from 'phosphor-react-native/src/icons/XCircle'
import YinYang from 'phosphor-react-native/src/icons/YinYang'

export const iconMap = {
  'address-book': AddressBook,
  'align-left': AlignLeft,
  'apple-logo': AppleLogo,
  'arrow-bend-up-left': ArrowBendUpLeft,
  'arrow-clockwise': ArrowClockwise,
  'arrow-counter-clockwise': ArrowCounterClockwise,
  'arrow-left': ArrowLeft,
  'arrow-line-right': ArrowLineRight,
  'arrow-right': ArrowRight,
  'arrow-square-right': ArrowSquareRight,
  'arrows-clockwise': ArrowsClockwise,
  'arrows-down-up': ArrowsDownUp,
  'arrows-left-right': ArrowsLeftRight,
  'arrows-out-simple': ArrowsOutSimple,
  avocado: Avocado,
  baby: Baby,
  barbell: Barbell,
  barcode: Barcode,
  bed: Bed,
  bell: Bell,
  'bell-ringing': BellRinging,
  'bell-simple': BellSimple,
  bluetooth: Bluetooth,
  bone: Bone,
  'book-open': BookOpen,
  'book-open-text': BookOpenText,
  'bookmark-simple': BookmarkSimple,
  'bowl-food': BowlFood,
  brain: Brain,
  cake: Cake,
  calculator: Calculator,
  calendar: Calendar,
  'calendar-blank': CalendarBlank,
  'calendar-check': CalendarCheck,
  'calendar-plus': CalendarPlus,
  'calendar-x': CalendarX,
  camera: Camera,
  'caret-down': CaretDown,
  'caret-left': CaretLeft,
  'caret-right': CaretRight,
  'caret-up': CaretUp,
  carrot: Carrot,
  'chart-bar': ChartBar,
  'chart-line': ChartLine,
  'chart-line-up': ChartLineUp,
  chat: Chat,
  'chat-circle': ChatCircle,
  'chat-circle-text': ChatCircleText,
  'chat-text': ChatText,
  'chats-circle': ChatsCircle,
  check: Check,
  'check-circle': CheckCircle,
  checks: Checks,
  circle: Circle,
  'circle-dashed': CircleDashed,
  clock: Clock,
  'clock-countdown': ClockCountdown,
  'clock-counter-clockwise': ClockCounterClockwise,
  cloud: Cloud,
  'cloud-arrow-up': CloudArrowUp,
  coin: Coin,
  coins: Coins,
  command: Command,
  confetti: Confetti,
  cookie: Cookie,
  copy: Copy,
  'corners-out': CornersOut,
  'credit-card': CreditCard,
  'device-mobile-camera': DeviceMobileCamera,
  'dots-six-vertical': DotsSixVertical,
  'dots-three': DotsThree,
  'dots-three-vertical': DotsThreeVertical,
  drop: Drop,
  'envelope-open': EnvelopeOpen,
  'envelope-simple': EnvelopeSimple,
  export: Export,
  eye: Eye,
  'eye-closed': EyeClosed,
  'facebook-logo': FacebookLogo,
  'faders-horizontal': FadersHorizontal,
  'file-arrow-down': FileArrowDown,
  'file-text': FileText,
  files: Files,
  'first-aid': FirstAid,
  fish: Fish,
  flag: Flag,
  flame: Flame,
  flask: Flask,
  'flower-lotus': FlowerLotus,
  footprints: Footprints,
  'fork-knife': ForkKnife,
  funnel: Funnel,
  gauge: Gauge,
  gear: Gear,
  'gender-female': GenderFemale,
  'gender-male': GenderMale,
  gift: Gift,
  grains: Grains,
  hamburger: Hamburger,
  'hand-heart': HandHeart,
  'hand-waving': HandWaving,
  heart: Heart,
  heartbeat: Heartbeat,
  'hourglass-simple-medium': HourglassSimpleMedium,
  'house-simple': HouseSimple,
  'identification-card': IdentificationCard,
  image: Image,
  info: Info,
  'instagram-logo': InstagramLogo,
  'jar-label': JarLabel,
  key: Key,
  lifebuoy: Lifebuoy,
  lightbulb: Lightbulb,
  'lightbulb-filament': LightbulbFilament,
  lightning: Lightning,
  'lightning-slash': LightningSlash,
  link: Link,
  'link-simple-horizontal': LinkSimpleHorizontal,
  'list-bullets': ListBullets,
  'list-checks': ListChecks,
  lock: Lock,
  'lock-simple': LockSimple,
  'lock-simple-open': LockSimpleOpen,
  'magnifying-glass': MagnifyingGlass,
  microphone: Microphone,
  'microphone-slash': MicrophoneSlash,
  microscope: Microscope,
  minus: Minus,
  moon: Moon,
  'moon-stars': MoonStars,
  note: Note,
  'note-pencil': NotePencil,
  notepad: Notepad,
  'paper-plane-tilt': PaperPlaneTilt,
  pause: Pause,
  'pause-circle': PauseCircle,
  pen: Pen,
  pencil: Pencil,
  'pencil-line': PencilLine,
  'pencil-simple': PencilSimple,
  'pencil-simple-line': PencilSimpleLine,
  percent: Percent,
  'person-arms-spread': PersonArmsSpread,
  'person-simple': PersonSimple,
  'person-simple-bike': PersonSimpleBike,
  'person-simple-run': PersonSimpleRun,
  'person-simple-swim': PersonSimpleSwim,
  'person-simple-walk': PersonSimpleWalk,
  pill: Pill,
  'pint-glass': PintGlass,
  plant: Plant,
  play: Play,
  'play-circle': PlayCircle,
  plus: Plus,
  prohibit: Prohibit,
  pulse: Pulse,
  'push-pin': PushPin,
  question: Question,
  'radio-button': RadioButton,
  record: Record,
  ruler: Ruler,
  scales: Scales,
  scan: Scan,
  seal: Seal,
  'seal-check': SealCheck,
  'seal-question': SealQuestion,
  'selection-slash': SelectionSlash,
  share: Share,
  'share-network': ShareNetwork,
  'shield-check': ShieldCheck,
  'shield-slash': ShieldSlash,
  'shield-star': ShieldStar,
  'shield-warning': ShieldWarning,
  'shopping-cart': ShoppingCart,
  'shopping-cart-simple': ShoppingCartSimple,
  'sign-out': SignOut,
  'sliders-horizontal': SlidersHorizontal,
  smiley: Smiley,
  sparkle: Sparkle,
  'speaker-low': SpeakerLow,
  'speaker-simple-high': SpeakerSimpleHigh,
  'speaker-simple-slash': SpeakerSimpleSlash,
  'squares-four': SquaresFour,
  stack: Stack,
  star: Star,
  'star-four': StarFour,
  steps: Steps,
  stethoscope: Stethoscope,
  syringe: Syringe,
  tag: Tag,
  target: Target,
  'test-tube': TestTube,
  thermometer: Thermometer,
  'thumbs-down': ThumbsDown,
  'thumbs-up': ThumbsUp,
  timer: Timer,
  trash: Trash,
  'trash-simple': TrashSimple,
  'trend-up': TrendUp,
  triangle: Triangle,
  truck: Truck,
  user: User,
  'user-plus': UserPlus,
  users: Users,
  video: Video,
  'video-camera': VideoCamera,
  virus: Virus,
  warning: Warning,
  'warning-circle': WarningCircle,
  'warning-octagon': WarningOctagon,
  'wave-triangle': WaveTriangle,
  'wave-form': Waveform,
  waves: Waves,
  'wifi-x': WifiX,
  wine: Wine,
  x: X,
  'x-circle': XCircle,
  'yin-yang': YinYang,
}
